import { logError } from '../../services/sentryService';
import CONSTANTS from '../../lib/constants';

export const Action = {
  SHOW_SUGGESTIONS: 'SHOW_SUGGESTIONS',
  BACK_TO_EDIT: 'BACK_TO_EDIT',
  SAVE_SELECTED_ADDRESS: 'SAVE_SELECTED_ADDRESS',
  ACCEPT_AUTOMATICALLY: 'ACCEPT_AUTOMATICALLY',
  NO_SUGGESTIONS: 'NO_SUGGESTIONS',
  SUGGESTIONS_REJECTED: 'SUGGESTIONS_REJECTED',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
};
export const AddressUtils = {
  check: (viewModel, addressType, element = '') => {
    if (typeof window.AddressValidation !== 'object') {
      logError('AddressValidation JS is not properly loaded.');
      goNextStep(viewModel, addressType);
      return;
    }

    viewModel.sectionsModel[addressType].isValidated = false;
    const { address = {} } = viewModel.sectionsModel[addressType].data;
    const { name = 'Deutschland', iso3166Name = 'DE' } =
      viewModel.countrySelects[addressType].selectedCountry;
    address.country = name;
    address.countryCode = iso3166Name;
    address.type = addressType;

    window.AddressValidation.renderComponent(
      {
        enteredAddress: address,
        customerInfo: address,
        consumerName: 'registration',
        config: {
          executionEnvironment: window.environment,
          realm: window.realm,
          locale: window.locale,
        },
        callback: (callbackData) => {
          if (typeof callbackData === 'object') {
            handleActions(viewModel, addressType, callbackData);
          } else {
            goNextStep(viewModel, addressType);
          }
        },
      },
      element
    );
  },
};

const handleActions = (viewModel, addressType, callbackData) => {
  const { action, payload = {} } = callbackData;
  switch (action) {
    case Action.SHOW_SUGGESTIONS: {
      viewModel.sectionsModel[addressType].showSuggestions = true;
      viewModel.submit = false;
      viewModel.$timeout(() => viewModel.$scope.$apply, 0);
      viewModel.scrollToSection(addressType);
      break;
    }
    case Action.BACK_TO_EDIT: {
      viewModel.setSelectedAddress(addressType, 'edit');
      break;
    }
    case Action.ACCEPT_AUTOMATICALLY:
    case Action.SAVE_SELECTED_ADDRESS: {
      saveAddress(viewModel, addressType, payload);
      break;
    }
    case Action.SUGGESTIONS_REJECTED:
    case Action.VALIDATION_FAILED:
    case Action.NO_SUGGESTIONS: {
      goNextStep(viewModel, addressType, payload);
      break;
    }
  }
};

const saveAddress = (viewModel, addressType, payload) => {
  const ENTERED_ADDRESS_INDEX = 3;
  const { address, isEntered, firstSuggestion = {} } = payload;
  let data = { ...address.basicInfo, ...address.additionalInfo };

  if (data.suggestionStatus === Action.SHOW_SUGGESTIONS) {
    data.suggestionStatus = 'ACCEPTED';
  }

  let addressIndex = 0;
  if (isEntered) {
    addressIndex = ENTERED_ADDRESS_INDEX;
    data = firstSuggestion.additionalInfo;
    data.suggestionStatus = 'NOT_ACCEPTED';
  }
  viewModel.sectionsModel[addressType].data.allSuggestions = [data];
  viewModel.sectionsModel[addressType].data.suggestion = addressIndex;
  viewModel.setSelectedAddress(addressType);
};

const goNextStep = (viewModel, addressType, payload = {}) => {
  const { address = {} } = payload;
  viewModel.sectionsModel[addressType].data.acceptedSuggestion = false;
  viewModel.sectionsModel[addressType].data.validatedAddress =
    address.additionalInfo;

  if (
    payload.address?.additionalInfo?.infoCode ===
    CONSTANTS.ERROR_MESSAGES.UNKNOWN_CITY
  ) {
    viewModel.sectionsModel[addressType].data.unknownCity = true;
    return viewModel.showAddressFormBySectionName(addressType);
  }
  viewModel.setAddressFlow(addressType);
};
